import { Button, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCarrierQualification extends Layout {
    buttonQualDetails: Button;
    panelMain: Panel;
    panelResults: Panel;
    textboxProfile: Textbox;
}
